export const API_URL_USER =
  "https://mern-income-expenses-tracker-backend.onrender.com/api/v1/users";
export const API_URL_ACC =
  "https://mern-income-expenses-tracker-backend.onrender.com/api/v1/accounts";
export const API_URL_TRANSACTION =
  "https://mern-income-expenses-tracker-backend.onrender.com/api/v1/transactions";
